import { render } from "./ChannelsTelegramCreateModal.vue?vue&type=template&id=53ca4077&scoped=true&ts=true"
import script from "./ChannelsTelegramCreateModal.vue?vue&type=script&lang=ts"
export * from "./ChannelsTelegramCreateModal.vue?vue&type=script&lang=ts"

import "./ChannelsTelegramCreateModal.vue?vue&type=style&index=0&id=53ca4077&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ca4077"]])

export default __exports__